function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "21.05 14.86 7.42 14.86 7.42 5.31 21.05 5.31 18.66 10.08 21.05 14.86",
    style: {
      fill: "#d45151"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.68,
    y: 5.31,
    width: 1.63,
    height: 15.75,
    style: {
      fill: "#d45151"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45,
    cy: 4.72,
    r: 1.42,
    style: {
      fill: "#d45151"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag_icon.612bb44837e203bbde092cf7b8578efb.svg";
export { ForwardRef as ReactComponent };